import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";

import { isEndWithConsonant } from "../../../utils/status";

const HomeRecommendHorizontal = ({ type, categoryList }) => {
	const history = useHistory();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const [typeKr, setTypeKr] = useState("");
	// const bgColor = reduxChannel?.color_2 ? reduxChannel?.color_2 : "#272847";

	const [category, setCategory] = useState({
		left: [],
		right: [],
	});
	const [mediaResult, setMediaResult] = useState(null);
	useEffect(() => {
		if (typeof window !== "undefined") {
			const matchQueryList = window.matchMedia("all and (max-width: 768px)");
			setMediaResult(matchQueryList.matches);

			const media = function handleChange(e) {
				setMediaResult(e.matches);
			};

			matchQueryList.addEventListener("change", media);
		}
	}, []);

	useEffect(() => {
		let left = [];
		let right = [];
		for (let i = 0; i < categoryList?.length; i++) {
			if (i % 2) {
				right.push(categoryList[i]);
			} else {
				left.push(categoryList[i]);
			}
		}
		if (
			left?.length + right?.length === categoryList?.length &&
			(left?.length !== category.left?.length ||
				right?.length !== category.right?.length)
		) {
			setCategory({
				left: left,
				right: right,
			});
			// setSecond((Math.random() * 10).toFixed() % 4);
		}
	}, [categoryList]);

	useEffect(() => {
		if (type === "combination") {
			setTypeKr("조합별");
			// setBgColor(bgCombination);
		} else if (type === "ingredient") {
			setTypeKr("성분별");
			// setBgColor(bgIngredient);
		} else {
			setTypeKr("고민별");
			// setBgColor(bgFunction);
		}
	}, [type]);

	// const bgColorHotBest = (item) => {
	//     if (item.is_hot) {
	//         return "#fe2b4b"
	//     } else if (item.is_best) {
	//         return "#ff8000"
	//     } else {
	//         return bgColor
	//     }
	// }

	return (
		<div
			className={`home-each`}
			style={{
				// backgroundColor: "#eaeff6"
				backgroundColor: "#e5f0ff",
			}}
		>
			<div className={`max-width-apply`}>
				<div
					className={`${
						mediaResult
							? "home-recommend-vertical"
							: "home-recommend-horizontal"
					}`}
				>
					<div className={`recommend-title`}>
						<p className={`type-kr`}>
							{reduxChannel?.user_id === 9 ? "고민별" : typeKr}
						</p>
						<p className={`title`}>
							{reduxChannel?.name}
							{isEndWithConsonant(reduxChannel?.name) ? "이" : "가"} 정리한
							{"\n"}
							{reduxChannel?.user_id === 9 ? "고민별" : typeKr} 정보
						</p>
					</div>
					{mediaResult ? (
						<div className={`recommend-list-group`}>
							<div className={`recommend-list left`}>
								{category.left?.map((item, idx) => (
									<div
										className={`recommend-each`}
										style={{
											// backgroundColor: item?.bg_color,
											background: `${
												item?.bg_color
											} no-repeat right bottom /100% url("${
												process.env.REACT_APP_HOST
											}/assets/images/channel/recommend-${
												idx % 2 ? 2 : 0
											}.png")`,
										}}
										key={`left ${idx}`}
										onClick={() =>
											history.push(
												`/together/channel/${type}s/detail/${
													item[
														`${type === "combination" ? `id` : `${type}_id`}`
													]
												}?id=` + reduxChannel?.influencer_id
											)
										}
									>
										<div className={`recommend-category-name-div`}>
											{type === "combination" ? (
												<p className={`category-name`}>{item?.category_name}</p>
											) : (
												<p className={`category-name`}>
													{item[`${type}_name`]}
												</p>
											)}
											<img
												src={`/assets/images/channel/${
													mediaResult ? "arrow-mobile" : "line-arrow-icon"
												}.png`}
												alt={`이미지 홈 성분별`}
												style={{
													height: "2em",
													width: "auto",
												}}
											/>
										</div>

										{item.is_hot && (
											<img
												src={`/assets/images/channel/hot.png`}
												alt={`이미지 홈 성분별`}
												className={`channel-point`}
											/>
										)}

										{item.is_best && (
											<img
												src={`/assets/images/channel/best.png`}
												alt={`이미지 홈 성분별`}
												className={`channel-point`}
											/>
										)}
									</div>
								))}
							</div>
							<div className={`recommend-list right`} style={{ padding: 0 }}>
								{category.right?.map((item, idx) => (
									<div
										className={`recommend-each`}
										style={{
											// backgroundColor: item?.bg_color,
											background: `${
												item?.bg_color
											} no-repeat right bottom /100% url("${
												process.env.REACT_APP_HOST
											}/assets/images/channel/recommend-${
												idx % 2 ? 3 : 1
											}.png")`,
										}}
										key={`right ${idx}`}
										onClick={() =>
											history.push(
												`/together/channel/${type}s/detail/${
													item[
														`${type === "combination" ? `id` : `${type}_id`}`
													]
												}?id=` + reduxChannel?.influencer_id
											)
										}
									>
										<div className={`recommend-category-name-div`}>
											{type === "combination" ? (
												<p className={`category-name`}>{item?.category_name}</p>
											) : (
												<p className={`category-name`}>
													{item[`${type}_name`]}
												</p>
											)}
											<img
												src={`/assets/images/channel/${
													mediaResult ? "arrow-mobile" : "line-arrow-icon"
												}.png`}
												alt={`이미지 홈 성분별`}
												style={{
													height: "2em",
													width: "auto",
												}}
											/>
										</div>

										{item.is_hot && (
											<img
												src={`/assets/images/channel/hot.png`}
												alt={`이미지 홈 성분별`}
												className={`channel-point`}
											/>
										)}

										{item.is_best && (
											<img
												src={`/assets/images/channel/best.png`}
												alt={`이미지 홈 성분별`}
												className={`channel-point`}
											/>
										)}
									</div>
								))}
							</div>
						</div>
					) : (
						<div className={`recommend-list-group`}>
							{categoryList?.map((item, idx) => (
								<div
									className={`recommend-each`}
									style={{
										// backgroundColor: item?.bg_color,
										background: `${
											item?.bg_color
										} no-repeat right bottom /100% url("${
											process.env.REACT_APP_HOST
										}/assets/images/channel/recommend-${idx % 2 ? 2 : 0}.png")`,
									}}
									key={`recommend ${type} ${idx}`}
									onClick={() =>
										history.push(
											`/together/channel/${type}s/detail/${
												item[`${type === "combination" ? `id` : `${type}_id`}`]
											}?id=` + reduxChannel?.influencer_id
										)
									}
								>
									<div className={`recommend-category-name-div`}>
										{type === "combination" ? (
											<p className={`category-name`}>{item?.category_name}</p>
										) : (
											<p className={`category-name`}>{item[`${type}_name`]}</p>
										)}
										<img
											src={`/assets/images/channel/line-arrow-icon.png`}
											alt={`이미지 홈 성분별`}
											style={{
												height: "2em",
												width: "auto",
											}}
										/>
									</div>

									{item.is_hot && (
										<img
											src={`/assets/images/channel/hot.png`}
											alt={`이미지 홈 성분별`}
											className={`channel-point`}
										/>
									)}

									{item.is_best && (
										<img
											src={`/assets/images/channel/best.png`}
											alt={`이미지 홈 성분별`}
											className={`channel-point`}
										/>
									)}
								</div>
							))}
						</div>
					)}
					<Link
						to={`/together/channel/${type}s?id=${reduxChannel?.influencer_id}`}
						className={`recommend-button mobile-show`}
					>
						전체보기
					</Link>
					<Link
						to={`/together/channel/${type}s?id=${reduxChannel?.influencer_id}`}
						className={`recommend-button`}
					>
						전체보기
					</Link>
				</div>
			</div>
		</div>
	);
};
export default HomeRecommendHorizontal;
